module.exports = __webpack_public_path__ + "static/banner_home_tablet-c4252686c88224033b86b26b968dfb25.jpg";